import { Alert, Text, VStack } from '@enechain/ecloud-designsystem'

/**
 * 確認モーダルで確定を止めない注意の文を 1 枚の warning Alert に、 渡された順に同じ扱いで並べる。
 * 空なら描画しない。
 */
export const WarningMessagesAlert = ({
  messages,
}: {
  messages: readonly string[]
}): React.ReactElement | null => {
  if (messages.length === 0) return null
  return (
    <Alert
      description={
        <VStack align="stretch" gap={1}>
          {messages.map((message) => (
            <Text key={message}>{message}</Text>
          ))}
        </VStack>
      }
      status="warning"
    />
  )
}
